<template>
  <div class="container d-flex align-items-center min-vh-100">
    <div class="row w-100 justify-content-center">
      <div class="col" md="6">
        <div class="w-100">
          <div class="no-results d-flex flex-column justify-content-center align-items-center p-5 w-100">
            <img class="no-results-img my-2" src="../assets/logo_fill.svg"/>
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">{{$t("page404.title")}}</h4>
            <p class="text-muted">{{$t("page404.text")}}</p>
            <button class="btn" @click="goHome">{{$t("vueRouter.home")}}</button>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_HELPER } from "@/helpers/api.js";
export default {
  name: 'Page404',
  metaInfo () {
      return { 
            title: `${this.$t("vueRouter.errorPageTitle")} - FactoryPlay`, 
            htmlAttrs: {
                lang: this.$i18n.locale,
            },
            link: [
                {rel: 'alternate', hreflang: 'en', href: API_HELPER.pathJoin([process.env.VUE_APP_FRONT, this.$t("vueRouter.errorPage", 'en')])},
                {rel: 'alternate', hreflang: 'pt', href: API_HELPER.pathJoin([process.env.VUE_APP_FRONT, this.$t("vueRouter.errorPage", 'pt')])},
                {rel: 'alternate', hreflang: 'es', href: API_HELPER.pathJoin([process.env.VUE_APP_FRONT, this.$t("vueRouter.errorPage", 'es')])},
            ]
        } 
    },
    methods: 
    {
        goHome: function()
        {
            this.$router.push("/");
        }
    }
}
</script>

<style scoped>
.no-results-img
{
    width: 30%;
    min-width: 200px;
}
.btn {
  background: #17224d;
  color: white;
  padding: 5px 100px;
  font-size: 20px;
}
.btn:hover {
  color: white;
}
</style>